import React from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import cookie from 'react-cookies'
import { authenticateSuccess, logout } from "../../utils/Session";
import { adminUrl, frontUrl } from '../../utils/GetUrl'
import { request } from '../../utils/request'

//withRouter一定要写在前面，不然路由变化不会反映到props中去
@withRouter @inject('appStore') @observer
class HeaderBar extends React.Component {
    state = {
        avatar: require('./img/04.jpg')
    }

    // logout = () => {
    //     console.log('点击了')
    //     this.props.appStore.toggleLogin(false);
    //     // cookie.remove("bcz_internal_token", {domain:".baicizhan.com"});
    //     logout();
    //     authenticateSuccess("false");
    //     cookie.remove("groupId",{ path: "/"});
    //     cookie.remove("cnName",{ path: "/"});
    //     cookie.remove("userId",{ path: "/"});
    //     cookie.remove("groupName",{ path: "/"});
    //     cookie.remove("role",{ path: "/"});
    //     cookie.remove("bcz_internal_token", {path:"/"});
    //     cookie.remove("bcz_internal_token", {path:"/home"});
    //     cookie.remove("isLogin", {path:"/"});
    //     sessionStorage.removeItem("groupName");
    //     sessionStorage.removeItem("role");
    //     console.log('清除完毕')
    //     console.log(cookie.load('userId'))
    // }
    // Astop() {
    //     this.refs.mar.stop();
    // }

    // Astart() {
    //     this.refs.mar.start();
    // }
    render() {
        const { appStore } = this.props;

        return (
            <div id='headerbar'>
                {/* <marquee width="1000" hspace="20" vspace="10" ref="mar" onMouseOver={this.Astop.bind(this)} onMouseOut={this.Astart.bind(this)}>
                    <font color="red">
                       今下午四点将对日志状态及日志事件做更新操作，届时会将所有记录清除，请在此之前处理完所有日志事件，之后带有查询语句必须对__time__起别名dt
                    </font>
                </marquee> */}
                <div style={{ lineHeight: '64px', float: 'right' }}>

                    <ul className='header-ul'>
                        <li>
                            你好,{cookie.load("cnName") == null ? "" : cookie.load("cnName")}-{cookie.load("groupName")}
                        </li>
                        {/* <li>
                            <a onClick={()=>this.logout()}>退出登录</a>
                        </li> */}
                    </ul>
                </div>
            </div>
        )
    }
}

export default HeaderBar



// WEBPACK FOOTER //
// ./src/components/HeaderBar/index.js